// Erreur unique pour tous les échecs d'API. `kind` permet de discriminer sans
// analyser les messages :
//   'network'  la requête n'a pas abouti
//   'http'     le serveur a répondu hors 2xx/3xx
//   'parse'    réponse illisible (api.php ne pose pas de Content-Type)
//   'expired'  session morte côté serveur -> retour au login
//   'nok'      action refusée par l'API (le motif est dans `data.content` :
//              "file_exist", "offset_mismatch"…)
export class ClodoError extends Error {
    constructor(kind, message, data){
        super(message);
        this.name = 'ClodoError';
        this.kind = kind;
        this.data = data;
    }
}
